import * as React from 'react';
import { Tree } from '@salesforce/design-system-react';
import { ScreenName, NavRedirector, TreeClickNode, TreeItem } from 'lib/types';
import './nav.css';

interface NavigationProps {
	onClick: (name: ScreenName) => void;
	navRedirector: NavRedirector;
	nav: ScreenName;
	nodes: TreeItem[];
}
interface NavigationState {
	currentBranch?: TreeItem;
	nodes: TreeItem[];
}

export class Navigation extends React.Component<NavigationProps, NavigationState> {
	constructor (props: NavigationProps) {
		super(props);
		this.state = {
			nodes: props.nodes
		};
	}

	componentWillReceiveProps (nextProps: NavigationProps) {
		if (nextProps.nav !== this.props.nav) {
			const navName = mapNameToTree(nextProps.nav);
			const newNodes = highlightNode(unHighlightNodes(this.state.nodes), navName);
			this.setState({ nodes: newNodes });
		}
	}

	handleClick = (event: React.UIEvent<{}>, node: TreeClickNode) => {
		const currentScreen = this.props.nav;
		const isDisabled = node.node.disabled;
		let clickedNav = this.props.navRedirector(currentScreen, node.node.id);

		if (isDisabled) { return; }

		const newNodes = highlightNode(unHighlightNodes(this.state.nodes), clickedNav);

		this.setState({ nodes: newNodes });
		if (clickedNav as string !== 'customer-hub') {
			this.props.onClick(clickedNav as ScreenName);
		}
	}

	render () {
		return (
			<Tree
				heading="Setup"
				id="setup-nav"
				listClassName="nav-tree"
				nodes={this.state.nodes}
				onClick={this.handleClick}
				onExpandClick={this.handleClick}
			/>
		);
	}
}

// Maps some nav names to different tree items, because some screens share a single nav item
function mapNameToTree (name: ScreenName): string {
	switch (name) {
		case 'dashboard':
		case 'dashboard2':
		case 'dashboard3':
		case 'dashboard-auth':
			return 'home';
		default:
			return name;
	}
}

// Recursively removes all highlighting and expanding from the nodes tree
function unHighlightNodes (nodes: TreeItem[]): TreeItem[] {
	return nodes.map((n) => {
		n.selected = false;
		// n.expanded = false;
		if (n.nodes) {
			n.nodes = unHighlightNodes(n.nodes);
		}
		return n;
	});
}

// Adds selection (and maybe expansion) to an item given an ID name
function highlightNode (nodes: TreeItem[], name: string, branch: TreeItem | null = null): TreeItem[] {
	nodes.forEach(n => {
		if (n.id === name) {
			n.selected = true;
			if (n.type === 'branch' && n.nodes) {
				n.expanded = true;
			}
			if (branch) { // FIXME: this will only open a branch one level deep
				branch.expanded = true;
			}
		}
		if (n.type === 'branch') {
			n.nodes = highlightNode(n.nodes || [], name, n);
		}
	});

	return nodes;
}



// WEBPACK FOOTER //
// ./src/Nav/index.tsx